import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicFemiEstate from "../Components/ProjPicFemiEstate";

const ProjectPageFemiEstate = () => {
    return (
        <>
            <Navbar />
            <ProjPicFemiEstate />
            <Footer />
        </>
    );
};

export default ProjectPageFemiEstate;
